import { useParams } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";
import ScrollToTop from "@/components/base/ScrollToTop";
import CategoryTabs from "@/components/feature/CategoryTabs";
import ComicCard from "@/components/feature/ComicCard";
import { comics, categories } from "@/mocks/comics";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const activeSlug = slug || "all";

  const currentCategory = categories.find((c) => c.slug === activeSlug);

  const filteredComics =
    activeSlug === "all"
      ? comics
      : comics.filter((c) => c.category === activeSlug);

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main className="pt-16">
        <div className="bg-background-50 border-b border-background-200/70">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: currentCategory ? currentCategory.name : "全部分类" },
              ]}
            />
            <div className="px-4 md:px-6 pb-6">
              <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-1">
                {currentCategory ? currentCategory.name : "全部分类"}
              </h1>
              <p className="text-sm text-foreground-500 mb-6">
                {currentCategory
                  ? currentCategory.description
                  : "浏览全部漫画资源，发现更多精彩内容"}
              </p>
              <CategoryTabs
                categories={[{ id: "all", name: "全部", slug: "all", icon: "ri-apps-2-line" }, ...categories.filter((c) => c.id !== "all")]}
                activeCategory={activeSlug}
              />
            </div>
          </div>
        </div>

        <section className="w-full px-4 md:px-6 py-10">
          <div className="max-w-7xl mx-auto">
            {filteredComics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5" data-product-shop="">
                {filteredComics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto mb-4 bg-background-100 rounded-full flex items-center justify-center">
                  <i className="ri-emotion-sad-line text-2xl text-foreground-400"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画内容</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            name: `${currentCategory ? currentCategory.name : "全部分类"} - 羞羞色漫`,
            description: currentCategory
              ? currentCategory.description
              : "浏览全部漫画资源",
            url: `https://xiuxiuse.com/category/${activeSlug}`,
            isPartOf: {
              "@type": "WebSite",
              name: "羞羞色漫",
              url: "https://xiuxiuse.com",
            },
          }),
        }}
      />
    </>
  );
}